import { Component, Input } from '@angular/core';

@Component({
	selector: 'cmv-image-header-hive-header',
	templateUrl: './image-header-hive.component.html',
	styleUrls: ['./image-header-hive.component.scss'],
})
export class ImageHeaderHiveComponent {
	@Input()
	imageCaptureHeaderImg: string;
	@Input()
	imageCaptureHeaderTitle: string;
	@Input()
	isColemnaVisible: boolean;

	constructor() {}
}
